import { errors as lang_error } from '@/lang/ja_JP'
export default {
  /**
   * IE11 includes() 未実装
   * 互換関数
   */
  isIncludes (array, searchElem) {
    for (let item of array) {
      if (item === searchElem) {
        return true
      }
    }

    return false
  },
  dateToString (date) {
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
  },
  stringToDate (string) {
    // YYYY/MM/DD
    if (!string || !string.match(/^[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}$/)) {
      // フォーマットエラー
      return null
    }

    let year, month, day
    [year, month, day] = string.split('/')
    // Dateオブジェクト生成
    let date = new Date(year, month - 1, day)

    if (!date.getMonth() === month) {
      // フォーマットエラー
      return null
    }

    return date
  },
  /**
   * データインポート：ファイル読み込み
   * @param Object file
   * @returns {Promise<any>}
   */
  readFile (file) {
    return new Promise((resolve, reject) => {
      // 空ファイルチェック
      if (file.size <= 0) {
        // 'ファイルサイズが 0 バイト のファイルはインポートできません。'
        reject(new Error(lang_error.importDataErrorMessages[0]))
      }
      // jsonファイルチェック
      let fileName = file.name.split('.')
      if (fileName[fileName.length - 1] !== 'json') {
        // '拡張子が json のファイルを選択してください。'
        reject(new Error(lang_error.importDataErrorMessages[1]))
      }

      // ファイル読み込み
      const reader = new FileReader()
      reader.onload = (e) => {
        let result = ''
        try {
          result = JSON.parse(e.target.result)
        } catch (e) {
          // 解析不能
          // 'jsonの解析に失敗しました。'
          reject(new Error(lang_error.importDataErrorMessages[2]))
        }
        resolve(result)
      }
      reader.readAsText(file)
    })
  },
  /**
   *  ダウンロード処理を行う
   * @param response.data DL処理のレスポンスデータ
   * @param filename DLファイル名
   */
  getFileDL (data, filename) {
    if (window.navigator.msSaveBlob) {
      // IE用ダウンロード処理
      window.navigator.msSaveBlob(new Blob([data], {'type': data.type}), filename)
    }
    else {
      const url = window.URL.createObjectURL(new Blob([data], {'type': data.type}))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },

  /**
   * blobで返されたエラーメッセージをjsonに変換する
   * @param data
   * @returns {Promise<any>}
   */
  blobToJson (data) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()

      fileReader.onerror = () => {
        fileReader.abort()
        reject(new Error('レスポンスデータの読み込みに失敗しました。'))
      }

      fileReader.onload = () => {
        // TODO parseエラー想定しておく？
        resolve(JSON.parse(fileReader.result))
      }

      fileReader.readAsText(data)
    })
  },

  /**
   * formバリデーションで入力欄に自動フォーカスがあたる際に、
   * ヘッダーが浮いているとヘッダーの下に入力欄が隠れてしまう。
   * そのため、bodyをヘッダーの分下げて、windowではなくbodyをスクロールするようにした
   */
  elScroll: null,

  /**
   * アニメーションつきスクロール
   * @param destination 上からのスクロール値
   * @param callback
   */
  smoothScrollTo (destination, callback) {
    if (!this.elScroll) {
      this.elScroll = document.body
    }

    destination = destination || 0

    let step = this.elScroll.scrollTop / 30 // 30: 何回に分けて上に上がるか
    let interval = setInterval(() => {
      if (this.elScroll.scrollTop > destination) {
        this.elScroll.scrollTop -= step
      } else {
        clearInterval(interval)
        if (typeof callback === 'function') {
          callback()
        }
      }
    }, 15)
  },

  /**
   * アニメーションなしスクロール
   * @param el スクロール先の要素
   * @param callback
   */
  scrollToEl (el, callback) {
    if (!this.elScroll) {
      this.elScroll = document.body
    }
    this.elScroll.scrollTop = el.offsetTop
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js